import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-confirm-action-modal',
  templateUrl: 'confirm-action-modal.component.html',
  styleUrls: ['confirm-action-modal.component.scss'],
})
export class ConfirmActionModalComponent implements OnInit {
  @Input() title: string;
  @Input() description: string;
  @Input() withConsent: boolean;
  @Input() isWarning: boolean = false;
  @Input() showCloseWithNoAction: boolean = false;
  @Input() large: boolean = false;
  @Input() yesText: string = '';
  @Input() noText: string= '';

  consent: boolean;

  constructor(protected ref: NbDialogRef<ConfirmActionModalComponent>) {
  }

  ngOnInit() {
  }

  dismiss() {
    this.ref.close(false);
  }

  confirm() {
    this.ref.close(true);
  }

  abort() {
    this.ref.close(null);
  }
}
